import PropTypes from "prop-types";
import { Link } from "react-router";

import PageModalLink from "@/modules/page-modal-link";

import { TableTitleCellLinkType } from "./TableTitleCell.type";

const TableTitleCellLinkWrapper = ({ link, children }) => {
  if (!link) return children;

  if (typeof link === "string") {
    return <Link to={link}>{children}</Link>;
  }

  // link as object
  const { inModal, ...linkProps } = link;
  const LinkComponent = inModal ? PageModalLink : Link;

  return <LinkComponent {...linkProps}>{children}</LinkComponent>;
};

TableTitleCellLinkWrapper.propTypes = {
  link: TableTitleCellLinkType,
  children: PropTypes.node,
};

export default TableTitleCellLinkWrapper;
